import request from '../network';

export interface PetTagItem {
  id?: number;
  tagName?: string;
  petType?: string | number | null;
  sortNum?: number | null;
  createTime?: string | null;
}

export interface PetTagListParams {
  pageNum?: number | string;
  pageSize?: number | string;
  [key: string]: any;
}

export const getPetTagListApi = (params: PetTagListParams) => {
  return request<{
    total?: number;
    rows?: PetTagItem[];
    code: number;
    msg?: string;
  }>({
    url: '/member/royalcanin/admin/petTag/getList',
    method: 'GET',
    params,
  });
};

export const getPetTagListNotApi = (params: PetTagListParams) => {
  return request<{
    total?: number;
    rows?: PetTagItem[];
    code: number;
    msg?: string;
  }>({
    url: '/member/royalcanin/admin/petTag/getListNot',
    method: 'GET',
    params,
  });
};
